import React, { useState } from 'react';

const initialTags = [
    'Pets allowed', 'Free meal', 'Near me', 'Lunch nap', 'Shower',
    'Near the subway', 'Gym', 'Extra day offs', 'Free courses',
];

const CLRightPanel = () => {
    // const [tags, setTags] = useState(initialTags);
    const [selectedTags, setSelectedTags] = useState([]);

    const toggleTag = (tag) => {
        setSelectedTags((prev) =>
            prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
        );
    };

    return (
        <div className="w-full max-w-md mx-auto flex flex-col gap-6">
            {/* Job Alert Box */}
            <div className='flex flex-col bg-[#4E73F814] rounded-md px-4 sm:px-6 py-5 gap-2'>
                <p className='font-dmsans font-bold text-[#4E73F8] text-left'>
                    Be the first to see new jobs
                </p>
                <p className='font-dmsans font-normal text-[#757D8A] text-left'>
                    Activate the job alert now and never miss new jobs.
                </p>
                <input
                    type="text"
                    className='rounded-lg py-2 px-3 mt-3 text-left font-dmsans font-normal text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400'
                    placeholder="Enter email or keyword"
                />
                <button
                    className='bg-[#6989FE] hover:bg-blue-600 py-2 rounded-lg mt-2 text-white font-dmsans font-normal text-sm transition'
                >
                    Activate
                </button>
            </div>

            {/* Tags Section */}
            <div className='flex flex-wrap gap-3'>
                {initialTags.map((tag) => (
                    <button
                        key={tag}
                        onClick={() => toggleTag(tag)}
                        className={`px-4 py-1.5 text-sm rounded-full transition whitespace-nowrap ${selectedTags.includes(tag)
                            ? 'bg-blue-100 hover:bg-blue-200 text-blue-700 font-dmsans font-normal'
                            : 'bg-[#f0f0f0] hover:bg-gray-200 text-[#5A6474] font-dmsans font-normal'
                            }`}
                    >
                        {tag}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default CLRightPanel;
